/* Joi: bottom-centre ink toast pill (z-80). Rise+fade in, auto-dismiss 2.6 s.
   aria-live so screen readers announce cart/subscribe feedback. */

let region = null;
let timer = null;

function ensureRegion() {
  if (region) return region;
  region = document.createElement('div');
  region.className = 'joi-toast-region';
  region.setAttribute('aria-live', 'polite');
  document.body.appendChild(region);
  return region;
}

function show(message) {
  if (!message) return;
  const host = ensureRegion();
  clearTimeout(timer);
  host.textContent = '';
  const pill = document.createElement('div');
  pill.className = 'joi-toast';
  pill.textContent = message;
  host.appendChild(pill);
  timer = setTimeout(() => { host.textContent = ''; }, 2600);
}

window.JoiToast = { show };
document.addEventListener('joi:toast', (e) => show(e.detail?.message));
